/**
 * Figma MCP `get_design_context` — node 1:4558 (HOME INDEX DETAILS listing).
 */
export function directionToRatingVariant(direction) {
    if (!direction) {
        return null;
    }
    switch (direction.toLowerCase()) {
        case "improving":
            return "strong";
        case "stable":
            return "stable";
        case "worsening":
            return "vulnerable";
        default:
            return "unstable";
    }
}
/** MCP 1:4564–1:4619 — four rows as in Figma. */
export const HOME_INDEX_LISTING_DEFAULT_ROWS = [
    {
        nodes: {
            homeData: "1:4564",
            homeText: "1:4565",
            scoreData: "1:4575",
            scoreText: "1:4576",
            changeData: "1:4586",
            changeText: "1:4587",
            trendData: "1:4597",
            trendText: "1:4598",
            ratingData: "1:4608",
            ratingPill: "1:4609",
            ratingLabel: "1:4610",
        },
        homeName: "Pinecrest Residence",
        score: "70.06",
        change: { tone: "down-red", text: "▼ 0.58" },
        trend: "Worsening",
        rating: { variant: "vulnerable", label: "2 Vulnerable" },
    },
    {
        nodes: {
            homeData: "1:4566",
            homeText: "1:4567",
            scoreData: "1:4577",
            scoreText: "1:4578",
            changeData: "1:4588",
            changeText: "1:4589",
            trendData: "1:4599",
            trendText: "1:4600",
            ratingData: "1:4611",
            ratingPill: "1:4612",
            ratingLabel: "1:4613",
        },
        homeName: "Lakeside Estates",
        score: "70.06",
        change: { tone: "down-red", text: "▼ 0.58" },
        trend: "Worsening",
        rating: { variant: "vulnerable", label: "2 Vulnerable" },
    },
    {
        nodes: {
            homeData: "1:4568",
            homeText: "1:4569",
            scoreData: "1:4579",
            scoreText: "1:4580",
            changeData: "1:4590",
            changeText: "1:4591",
            trendData: "1:4601",
            trendText: "1:4602",
            ratingData: "1:4614",
            ratingPill: "1:4615",
            ratingLabel: "1:4616",
        },
        homeName: "Pinecrest Residence",
        score: "70.06",
        change: { tone: "up-green", text: "▲ 0.35" },
        trend: "Worsening",
        rating: { variant: "stable", label: "4 Stable" },
    },
    {
        nodes: {
            homeData: "1:4570",
            homeText: "1:4571",
            scoreData: "1:4581",
            scoreText: "1:4582",
            changeData: "1:4592",
            changeText: "1:4593",
            trendData: "1:4603",
            trendText: "1:4604",
            ratingData: "1:4617",
            ratingPill: "1:4618",
            ratingLabel: "1:4619",
        },
        homeName: "Lakeside Estates",
        score: "70.06",
        change: { tone: "down-red", text: "▼ 0.58" },
        trend: "Worsening",
        rating: { variant: "unstable", label: "4 Unstable" },
    },
];
